import store from '@/store';

export default (to, from, next) => {
    const allow = store.getters.is_show_fwa_module;

    return {
        allow,
        redirect: { name: 'not-found' },
    };
}